/**
 * @param {number} durationMs
 */
export function formatWorkedForLabel(durationMs) {
  const seconds = Math.max(1, Math.ceil((durationMs ?? 0) / 1000))
  return `Worked for ${seconds}s`
}
